/**
 * Deliberately import-free: this module is pulled in by `src/api/_baseUrl.ts`, which computes
 * module-level constants. Going through the `utils/utils` barrel (or even `./routing`, which reaches
 * `./format` -> `./misc` -> `api`) would put an import cycle in front of those constants and risk a
 * temporal-dead-zone crash at init.
 */
export const getEnvironment = (): 'local' | 'dev' | 'rc' | 'prod' => {
  const { hostname } = window.location;

  switch (hostname) {
    case 'localhost':
      return 'local';
    case 'partner.redamp.localhost':
      return 'local';
    case 'securitycheck-dev.ictmedia.cz':
      return 'dev';
    case 'partner.ictmedia.cz':
      return 'dev';
    case 'securitycheck-rc.redamp.eu':
      return 'rc';
    case 'partner.redamp.eu':
      return 'rc';
    case 'app.redamp.io':
      return 'prod';
    case 'partner.redamp.io':
      return 'prod';
    default:
      if (hostname.includes('.redamp.io')) return 'prod';

      return 'local';
  }
};
